import { Grid, Typography } from '@material-ui/core';
import { forwardRef } from 'react';
import { withScrollSpyItem } from './scroll-spy';

interface TitleProps {
  children: React.ReactNode;
  subTitle?: React.ReactNode;
  icon?: React.ReactNode;
  action?: React.ReactNode;
}

export const ScrollSectionTitle = withScrollSpyItem(
  forwardRef(({ children, icon, subTitle, id, action }: TitleProps & { id: string }, ref: any) => (
    <Grid container ref={ref} id={id} spacing={icon ? 2 : 0} alignItems="center" justify="space-between">
      <Grid item>
        <Grid container spacing={icon ? 2 : 0} alignItems="center">
          {icon && <Grid item>{icon}</Grid>}
          <Grid item>
            <Typography variant="h5">{children}</Typography>
            {subTitle && (
              <Typography color="textSecondary" variant="body2">
                {subTitle}
              </Typography>
            )}
          </Grid>
        </Grid>
      </Grid>
      {action && <Grid item>{action}</Grid>}
    </Grid>
  ))
);
